import { render } from "./distributor-book-cost-field.vue?vue&type=template&id=61312c28&scoped=true&ts=true"
import script from "./distributor-book-cost-field.vue?vue&type=script&lang=ts"
export * from "./distributor-book-cost-field.vue?vue&type=script&lang=ts"

import "./distributor-book-cost-field.vue?vue&type=style&index=0&id=61312c28&lang=css"
import "./distributor-book-cost-field.vue?vue&type=style&index=1&id=61312c28&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61312c28"]])

export default __exports__